import {WinPresentationModule} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationModule';
import {GameWinPresentationBasicState} from 'src/winpresentation/states/GameWinPresentationBasicState';
import {GameFlowEvents} from 'src/flow/GameFlowEvents';
import {GameWinPresentationBigWinWithMultiplierState} from 'src/winpresentation/states/GameWinPresentationBigWinWithMultiplierState';
import {GameWinPresentationInitialWinNoMultiplierState} from 'src/winpresentation/states/GameWinPresentationInitialWinNoMultiplierState';
import {GameWinPresentationInitialWinWithMultiplierState} from 'src/winpresentation/states/GameWinPresentationInitialWinWithMultiplierState';
import {WildMeterEvents} from 'src/wildmeter/WildMeterEvents';
import {GameWinPresentationView} from 'src/winpresentation/GameWinPresentationView';
import {GameWinPresentationEvents} from 'src/winpresentation/GameWinPresentationEvents';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';

export class GameWinPresentationModule extends WinPresentationModule {
	public static readonly WIN_WITH_MULTIPLIER_STATE: string = 'winwithmultiplierstate';
	public static readonly WIN_NO_MULTIPLIER_STATE: string = 'winnomultiplierstate';
	public static readonly BIG_WIN_WITH_MULTILPLER_STATE: string = 'bigwinwithmultiplierstate';

	protected setupStates(): void {
		this.addState(new GameWinPresentationBasicState(this, WinPresentationModule.BASIC));
		this.addState(new GameWinPresentationBigWinWithMultiplierState(this, GameWinPresentationModule.BIG_WIN_WITH_MULTILPLER_STATE));
		this.addState(new GameWinPresentationInitialWinNoMultiplierState(this, GameWinPresentationModule.WIN_NO_MULTIPLIER_STATE));
		this.addState(new GameWinPresentationInitialWinWithMultiplierState(this, GameWinPresentationModule.WIN_WITH_MULTIPLIER_STATE));
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onCurrentStateHandle(SpinButtonEvents.SKIP_BY_SPIN_BUTTON_PRESSED);
		this.onCurrentStateHandle(GameFlowEvents.HAS_WIN_WITH_MULTIPLIER);
		this.onCurrentStateHandle(GameFlowEvents.HAS_BIGWIN_WITH_MULTIPLIER);
		this.onCurrentStateHandle(GameFlowEvents.HAS_WIN_WITH_NO_MULTIPLIER);

		this.onCurrentStateHandle(WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_FINISHED);
		this.onCurrentStateHandle(GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED);

		this.onViewEmitEvent(GameWinPresentationView.AFTER_MULTIPLIER_COUNTING_FINISHED, GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED);
	}
}



// WEBPACK FOOTER //
// ./src/winpresentation/GameWinPresentationModule.ts